import { ThumbsUp, ThumbsDown } from "lucide-react";

type ResponseFeedbackProps = {
  onFeedback: (isPositive: boolean) => void;
  selectedFeedback: "positive" | "negative" | null;
};

export function ResponseFeedback({
  onFeedback,
  selectedFeedback,
}: ResponseFeedbackProps) {
  return (
    <div className="flex justify-end gap-2">
      <button
        onClick={() => onFeedback(true)}
        className={`p-2 rounded-full hover:bg-gray-100 ${
          selectedFeedback === "positive" ? "text-green-500" : "text-gray-500"
        }`}
      >
        <ThumbsUp className="w-5 h-5" />
      </button>
      <button
        onClick={() => onFeedback(false)}
        className={`p-2 rounded-full hover:bg-gray-100 ${
          selectedFeedback === "negative" ? "text-red-500" : "text-gray-500"
        }`}
      >
        <ThumbsDown className="w-5 h-5" />
      </button>
    </div>
  );
}
